import { render, staticRenderFns } from "./UsersForAppt.vue?vue&type=template&id=0cd07cf5&scoped=true"
import script from "./UsersForAppt.vue?vue&type=script&lang=js"
export * from "./UsersForAppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd07cf5",
  null
  
)

export default component.exports